import React, { useEffect, useState } from "react";
import { Bell, TriangleAlert, Clock, Info, CheckCheck } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, Card, Empty } from "@/components/ui/page";
import { fmtDateTime } from "@/lib/format";

const ICONS = { excess_break: TriangleAlert, break_warning: Clock, late_login: Clock, absent: Info, system: Info };
const COLORS = { excess_break: "#EF4444", break_warning: "#F59E0B", late_login: "#F59E0B", absent: "#6B7280", system: "#08A7A0" };

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const markRead = async (n) => {
    if (n.read) return;
    await api.post(`/notifications/${n.id}/read`);
    load();
  };

  return (
    <div>
      <PageHeader title="Notification Center" subtitle="Alerts, warnings and system messages" testId="notifications-header" />
      <Card className="p-2" testId="notifications-list">
        {items.length === 0 && <Empty label="You're all caught up" />}
        <div className="divide-y divide-slate-100">
          {items.map((n) => {
            const Icon = ICONS[n.type] || Bell;
            return (
              <button key={n.id} data-testid={`notif-${n.id}`} onClick={() => markRead(n)} className={`flex w-full items-start gap-3 px-4 py-4 text-left transition hover:bg-slate-50 ${n.read ? "opacity-60" : ""}`}>
                <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg" style={{ backgroundColor: `${COLORS[n.type] || "#08A7A0"}1A` }}>
                  <Icon className="h-4.5 w-4.5" style={{ color: COLORS[n.type] || "#08A7A0" }} />
                </div>
                <div className="flex-1">
                  <p className="text-sm font-medium text-[#0B1F33]">{n.message}</p>
                  <p className="mt-0.5 text-xs text-slate-400">{fmtDateTime(n.created_at)}</p>
                </div>
                {!n.read && <span className="mt-1 h-2 w-2 shrink-0 rounded-full bg-[#08A7A0]" />}
              </button>
            );
          })}
        </div>
      </Card>
    </div>
  );
}
